import { ICameraLicenseInfo, ICustomer, IFamilyLicenseUsage, ILicense, ILicenseLink, ILicenseV2, ILoadableWrapper, Loadable, createDefaultLoadable } from '../../models';

export interface IFamilyUsageState extends Loadable {
    data: Record<string, IFamilyLicenseUsage>;
}

export interface ISubscriptionState extends Loadable {
    distributorId: string,
    organisationDistributorId: string,
    customerCanRequest: boolean,
    customers: ICustomer[],
    licenses: ILoadableWrapper<ILicense>[],
    distributedLicenses: ILoadableWrapper<ILicense>[],
}

export interface LicenseState extends Loadable {
    licenses: ILicense[];
    v2Licenses: ILicenseV2[];
    v2Loading: boolean;
    v2Error: Error | null;
    entityLinks: ILicenseLink[];
    entityLinksLoading: boolean;
    entityLinksError: Error | null;
    cameraLicenses: Record<string, ICameraLicenseInfo[]>;
    cameraLicensesLoading: boolean;
    cameraLicensesError: Error | null;
    familyUsage: IFamilyUsageState;
    subscription: ISubscriptionState,
    distributeState: Loadable
}

export const initialLicenseState: LicenseState = {
    ...createDefaultLoadable(),
    licenses: [],
    v2Licenses: [],
    v2Loading: false,
    v2Error: null,
    entityLinks: [],
    entityLinksLoading: false,
    entityLinksError: null,
    cameraLicenses: {},
    cameraLicensesLoading: false,
    cameraLicensesError: null,
    familyUsage: { ...createDefaultLoadable(), data: {} },
    subscription: {
        ...createDefaultLoadable(),
        distributorId: "",
        organisationDistributorId: "",
        customerCanRequest: false,
        customers: [],
        licenses: [],
        distributedLicenses: []
    },
    distributeState: createDefaultLoadable()
};
